import { FormControlLabel, Grid, makeStyles, Paper, Radio, RadioGroup, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from '../../../hooks/useForm';
import { ESTUDIOS_MEDICOS_ESTADOS, OBRAS_SOCIALES } from '../../../utils/constants';
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";
import esLocale from "date-fns/locale/es";
import { cleanAfiliado, cleanAfiliadoSeleccionado, cleanEstudiosMedicos, clearReducer, getEstudiosMedicos, getEstudiosMedicosContadores, setEstadoEstudiosMedicos } from '../../../actions/turnos/estudiosMedicos';
import { EstudiosMedicosAfiliadoBuscador } from './EstudiosMedicosAfiliadoBuscador';
import { EstudiosMedicosItem } from './EstudiosMedicosItem';

const useStyles = makeStyles({
    root: {
        padding: 10,
        flexGrow: 1,
        marginTop: 10,
        // width: "100%",
    },
    input: {
        padding: 10,
    },
});

const stateInitial = {
    fechaInicio: moment().subtract(120, 'days'),
    fechaFin: moment(),
};


export const HomeEstudiosMedicos = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [dense, setDense] = useState(true);
    const [page, setPage] = useState(0);
    const [arrayEstadosEstudios, setArrayEstadosEstudios] = useState([]);
    const [idObraSocial, setIdObraSocial] = useState(OBRAS_SOCIALES.OSPEDYC);

    const {
        afiliadoSeleccionado = {},
        estadoEstudiosMedicos = 1,
        estudiosMedicos = {},
        estudiosMedicosContadores,
    } = useSelector((state) => state.estudiosMedicos);


    const [formValues, , , setearValor] = useForm(stateInitial);

    const { fechaInicio, fechaFin } = formValues;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const componentRef = React.useRef();

    useEffect(() => {
        if (!props.location.state?.fromHomeScreen) {
            dispatch(clearReducer());
            dispatch(cleanEstudiosMedicos());
            dispatch(cleanAfiliadoSeleccionado());
            dispatch(cleanAfiliado());
        }
    }, [dispatch]);

    useEffect(() => {
        const nuevosEstados = Object.entries(ESTUDIOS_MEDICOS_ESTADOS);
        setArrayEstadosEstudios(nuevosEstados); // Actualiza el estado
    }, [dispatch]);

    useEffect(() => {
        const fechaInicioFormateada = fechaInicio ? moment(fechaInicio).format('YYYY-MM-DD') : null;
        const fechaFinFormateada = fechaFin ? moment(fechaFin).format('YYYY-MM-DD') : null;

        dispatch(
            getEstudiosMedicos(
                estadoEstudiosMedicos,
                fechaInicioFormateada,
                fechaFinFormateada,
                afiliadoSeleccionado?.id_afiliado ? afiliadoSeleccionado?.id_afiliado : 0,
                idObraSocial
            )
        );
    }, [estadoEstudiosMedicos, afiliadoSeleccionado, fechaInicio, fechaFin]);

    useEffect(() => {
        const fechaInicioFormateada = fechaInicio ? moment(fechaInicio).format('YYYY-MM-DD') : null;
        const fechaFinFormateada = fechaFin ? moment(fechaFin).format('YYYY-MM-DD') : null;

        dispatch(
            getEstudiosMedicosContadores(
                estadoEstudiosMedicos,
                fechaInicioFormateada,
                fechaFinFormateada,
                afiliadoSeleccionado?.id_afiliado ? afiliadoSeleccionado?.id_afiliado : 0,
                idObraSocial
            )
        );
    }, [estadoEstudiosMedicos, afiliadoSeleccionado, fechaInicio, fechaFin]);


    return (
        <Grid container className={classes.root} justify="center" spacing={1}>
            <Grid item xs={12}>
                <Grid container direction="row" alignItems="center" spacing={1}>
                    <Grid item xs={12} md={8}>
                        <EstudiosMedicosAfiliadoBuscador idObraSocial={idObraSocial} setIdObraSocial={setIdObraSocial} hideTitle={true} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Paper className={classes.input}>
                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    label="Fecha Inicio"
                                    format="dd/MM/yyyy"
                                    required={true}
                                    clearLabel="Limpiar"
                                    cancelLabel="Cancelar"
                                    value={
                                        moment(fechaInicio).isValid() ? moment(fechaInicio) : null
                                    }
                                    onChange={(date) => {
                                        setearValor("fechaInicio", date);
                                    }}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Paper className={classes.input}>
                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    label="Fecha Fin"
                                    format="dd/MM/yyyy"
                                    required={true}
                                    clearLabel="Limpiar"
                                    cancelLabel="Cancelar"
                                    value={moment(fechaFin).isValid() ? moment(fechaFin) : null}
                                    onChange={(date) => {
                                        setearValor("fechaFin", date);
                                    }}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Paper style={{ padding: "0.25rem" }}>
                    <RadioGroup
                        row
                        style={{ justifyContent: "space-around" }}
                        value={estadoEstudiosMedicos?.toString()}
                        onChange={(e) => {
                            dispatch(setEstadoEstudiosMedicos(e.target.value));
                        }}
                    >
                        {arrayEstadosEstudios.map((estadoEstudio) => {
                            const contador = estudiosMedicosContadores.find(s => s.idEstado === estadoEstudio[1]);
                            const label =
                                estadoEstudio[0].charAt(0) +
                                estadoEstudio[0].replace("_", " ").toLowerCase().slice(1) +
                                ((contador && contador !== undefined)
                                    ?
                                    `(${contador.total})`
                                    :
                                    `(...)`
                                );
                            return (
                                <FormControlLabel
                                    key={estadoEstudio[1]?.toString()}
                                    style={{ marginLeft: "0.5rem" }}
                                    label={label}
                                    value={estadoEstudio[1]?.toString()}
                                    control={<Radio />}
                                />
                            );
                        })}
                    </RadioGroup>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <TableContainer component={Paper} style={{ overflowX: "auto" }}>
                    <Table size={dense ? "small" : "medium"} ref={componentRef}>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left">Fecha</TableCell>
                                <TableCell align="left">N° Estudio</TableCell>
                                <TableCell align="left">Afiliado</TableCell>
                                <TableCell align="left">Carnet</TableCell>
                                <TableCell align="left">Centro Medico</TableCell>
                                <TableCell align="left">Prof. Estudio</TableCell>
                                <TableCell align="left">Especialidad</TableCell>
                                <TableCell align="left">Tipo Estudio</TableCell>
                                <TableCell align="left">Problema</TableCell>
                                <TableCell align="left"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {estudiosMedicos.length > 0 ? (
                                // items.map((item) => (
                                estudiosMedicos
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((item) => (
                                        <EstudiosMedicosItem
                                            item={item}
                                            //permisosUser={permisosUser}
                                            key={item.id?.toString()}
                                            estadoEstudiosMedicos={estadoEstudiosMedicos}
                                            filtros={
                                                {
                                                    estadoEstudiosMedicos: estadoEstudiosMedicos,
                                                    fechaInicio: fechaInicio,
                                                    fechaFin: fechaFin,
                                                    idAfiliado: afiliadoSeleccionado?.idAfiliado ? afiliadoSeleccionado?.idAfiliado : 0,
                                                    idObraSocial: idObraSocial
                                                }
                                            }
                                            {...props}
                                        />
                                    ))
                            ) : (
                                <TableRow style={{ height: 50 }}>
                                    <TableCell
                                        colSpan={13}
                                        style={{ textAlign: "-webkit-center" }}
                                    >
                                        {" "}
                                        Sin Registros
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            {estudiosMedicos.length > 0 && (
                <Grid item xs={12}>
                    <TablePagination
                        style={{ backgroundColor: "white" }}
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={estudiosMedicos.length}
                        rowsPerPage={rowsPerPage}
                        labelRowsPerPage="Registros por página"
                        page={page}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={dense}
                                onChange={(e) => setDense(e.target.checked)}
                            />
                        }
                        label="Tamaño compacto"
                    />
                </Grid>
            )}
            {/* {redirect && (
        <Redirect
          to={{
            pathname: '/recetasDigitales',
            state: {
              from: '/recetasDigitales/gestion'
            },
          }}
        />
      )} */}
        </Grid>
    )
}
